// Tipovi dokumenata namjerno NISU SQLite CHECK constraint: CHECK se ne može
// proširiti bez rebuilda tabele. Ovo je jedini izvor istine, validira se Zodom.
export const DOCUMENT_TYPES = [
  "ugovor_terapeut",
  "ugovor_supervizor",
  "ugovor_firma",
  "aneks_ugovora",
  "saglasnost_klijent",
  "saglasnost_gdpr",
  "saglasnost_maloljetnik",
  "saglasnost_snimanje",
  "nda",
  "uslovi_koristenja",
  "politika_privatnosti",
  "eticki_kodeks",
  "pravilnik_otkazivanja",
  "protokol_krizne_situacije",
  "obrazac_prijava_terapeut",
  "obrazac_isplata",
  "obrazac_prigovor",
  "potvrda_terapija",
  "ostalo",
] as const;

export type DocumentType = (typeof DOCUMENT_TYPES)[number];

export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
  ugovor_terapeut: "Ugovor sa terapeutom",
  ugovor_supervizor: "Ugovor sa supervizorom",
  ugovor_firma: "Ugovor sa firmom",
  aneks_ugovora: "Aneks ugovora",
  saglasnost_klijent: "Informisani pristanak klijenta",
  saglasnost_gdpr: "Saglasnost za obradu podataka",
  saglasnost_maloljetnik: "Saglasnost staratelja",
  saglasnost_snimanje: "Saglasnost za snimanje sesije",
  nda: "Izjava o povjerljivosti",
  uslovi_koristenja: "Uslovi korištenja",
  politika_privatnosti: "Politika privatnosti",
  eticki_kodeks: "Etički kodeks",
  pravilnik_otkazivanja: "Pravilnik o otkazivanju",
  protokol_krizne_situacije: "Protokol za krizne situacije",
  obrazac_prijava_terapeut: "Obrazac za prijavu terapeuta",
  obrazac_isplata: "Obrazac zahtjeva za isplatu",
  obrazac_prigovor: "Obrazac prigovora",
  potvrda_terapija: "Potvrda o terapiji",
  ostalo: "Ostalo",
};

/** Grupe postoje samo radi UI filtera; u bazi ne postoje. */
export const DOCUMENT_TYPE_GROUPS: { label: string; types: DocumentType[] }[] = [
  {
    label: "Ugovori",
    types: ["ugovor_terapeut", "ugovor_supervizor", "ugovor_firma", "aneks_ugovora"],
  },
  {
    label: "Saglasnosti",
    types: [
      "saglasnost_klijent",
      "saglasnost_gdpr",
      "saglasnost_maloljetnik",
      "saglasnost_snimanje",
      "nda",
    ],
  },
  {
    label: "Pravni akti",
    types: [
      "uslovi_koristenja",
      "politika_privatnosti",
      "eticki_kodeks",
      "pravilnik_otkazivanja",
      "protokol_krizne_situacije",
    ],
  },
  {
    label: "Obrasci",
    types: [
      "obrazac_prijava_terapeut",
      "obrazac_isplata",
      "obrazac_prigovor",
      "potvrda_terapija",
    ],
  },
  { label: "Ostalo", types: ["ostalo"] },
];

export interface DocumentSummary {
  id: string;
  title: string;
  slug: string;
  type: DocumentType;
  description: string;
  isActive: boolean;
  hasSignatureBlock: boolean;
  currentVersionId: string | null;
  version: number;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface DocumentVersionSummary {
  id: string;
  documentId: string;
  version: number;
  contentJson: string;
  changeNote: string;
  createdBy: string;
  createdAt: string;
}

/** Dokument sa sadržajem aktivne verzije, kako ga vraća GET /api/documents/:id. */
export interface DocumentDetail extends DocumentSummary {
  contentJson: string;
}

/**
 * Dokument kako ga vidi neprijavljen korisnik: samo aktivna verzija, sa
 * placeholderima već popunjenim ili pretvorenim u praznu liniju. Vraća ga
 * GET /api/documents/public/:type.
 */
export interface PublicDocument {
  title: string;
  type: string;
  version: number;
  updatedAt: string;
  contentJson: string;
}

/**
 * Aktivni ugovor terapeuta sa placeholderima popunjenim podacima prijavljenog
 * terapeuta i stanjem prihvatanja. Vraća ga GET /api/therapist/contract.
 */
export interface TherapistContract {
  documentId: string;
  versionId: string;
  version: number;
  title: string;
  updatedAt: string;
  /** Tekst sa već popunjenim placeholderima (podaci iz baze). */
  contentJson: string;
  /** Isti tekst sa placeholderima, da ga onboarding popuni uživo iz unosa. */
  templateJson: string;
  /** Vrijednosti placeholdera iz baze za ovog terapeuta. */
  values: Record<string, string>;
  acceptedAt: string | null;
  acceptedVersion: number | null;
}
